<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card color="primary" dark>
          <v-card-title>
            <v-text-field
              v-model="stationName"
              label="Station"
              prepend-icon="mdi-memory"
              required
              readonly
            ></v-text-field>
          </v-card-title>
             <v-tabs
              v-model="tab"
              background-color="primary"
              color="white"
              show-arrows
              grow
              @change="getData(station,tab)"
            >
              <v-tabs-slider color="#0897d7"></v-tabs-slider>
              <v-tab
                v-for="item in items"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">

              <!-- Daily -->
              <v-tab-item>
                <v-card flat class="text-center">
                  <v-row>
                    <v-col>
                      <v-btn class="float-left" color="primary" icon @click="buttonLeftDaily">
                        <v-icon>mdi-arrow-left</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col>
                      <h2> {{monthName}}</h2>
                    </v-col>
                    <v-col>
                      <v-btn class="float-right" color="primary" icon @click="buttonRightDaily">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <Bar
                    :chart-options="chartOptions"
                    :chart-data="chartDataDaily"
                    :height="300"
                  />
                </v-card>
              </v-tab-item>

              <!-- Monthly -->
              <v-tab-item>
                <v-card flat>
                <v-row>
                  <v-col>
                    <v-btn class="float-left" color="primary" icon @click="buttonLeftMonthly">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <h2> {{year}}</h2>
                  </v-col>
                  <v-col>
                    <v-btn class="float-right" color="primary" icon @click="buttonRightMonthly">
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <Bar
                  :chart-options="chartOptions"
                  :chart-data="chartDataMonthly"
                  :height="300"
                />
                </v-card>
              </v-tab-item>

              <!-- Yearly -->
              <v-tab-item>
                <v-card flat>
                <Bar
                  :chart-options="chartOptions"
                  :chart-data="chartDataYearly"
                  :height="300"
                />
                </v-card>
              </v-tab-item>
            </v-tabs-items>

            
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"
import { Bar } from 'vue-chartjs/legacy'
import { loadPchChart } from '@/utils/pchChartData.js'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default ({
  components: { Bar },
  data: () => ({
    time:[],
    devices:[],
    data:[],
    offset:0,

    tab: null,
    items: [
      'Daily', 'Monthly', 'Yearly'
    ],
  
    dialog:false,
    ID:null,
    chartDataDaily: {
      labels: [],
      datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataMonthly: {
      labels: [],
      datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataYearly: {
      labels: [],
      datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartOptions: {
      responsive: true
    },
    headersDetail: [
        {
          text: 'Tanggal',
          align: 'start',
          value: 'tanggal',
        },
        { text: 'Curah (mm)', value: 'curah' },
      ],
    labels:[],
    datasets:[],
    location:null,
    locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
    station: null,
    stations:[],
    monthNum:0,
    monthName:'',
    year:2022,
    stationName:'',
    dataRequestId:0,
  }),
  async mounted() {
    this.station=localStorage.getItem('device')
    this.stationName=localStorage.getItem('station')
    console.log(this.location)
    const date=new Date();
    this.monthNum = date.getMonth()
    this.monthName = months[this.monthNum]
    this.year=date.getFullYear()
    this.getData(this.station,this.tab)
  },
  methods: {
    async getData(station,tab) {
      if (station==null || tab==null) return
      const requestId = ++this.dataRequestId
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)
      const loader = this.$loading.show()
      try {
        const result = await loadPchChart(db, {
          station,
          tab,
          year: this.year,
          monthNum: this.monthNum,
          offset: this.offset,
        })
        if (requestId !== this.dataRequestId) return
        this.monthName = months[this.monthNum]
        const chart = {
          labels: result.labels,
          datasets: [ { label: 'Curah',data: result.datasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
        }
        if (tab==0) this.chartDataDaily = chart
        else if (tab==1) this.chartDataMonthly = chart
        else if (tab==2) this.chartDataYearly = chart
      } catch (err) {
        console.error('Failed to load PCH chart', err)
      } finally {
        loader.hide()
      }
    },
    buttonLeftDaily() {
      if (this.monthNum!=0) {
        this.monthNum--
      } else {
        this.monthNum=11
        this.year--
      }
      this.getData(this.station,this.tab)
    },
    buttonRightDaily() {
      if (this.monthNum!=11) {
        this.monthNum++
      } else {
        this.monthNum=0
        this.year++
      }
      this.getData(this.station,this.tab)
    },
    buttonLeftMonthly() {
      this.year--
      this.getData(this.station,this.tab)
    },
    buttonRightMonthly() {
      this.year++
      this.getData(this.station,this.tab)
    }
  }
})
</script>

